<template>
	<div class="container bg-white p-3 border-15 shadow">
		<multi_step_progress
		:stepper_array="['احراز هویت', 'اطلاعات فردی', 'اطلاعات تکمیلی', 'اطلاعات تدریس', 'اطلاعات تحصیلی', 'درباره من', 'ارزیابی']"
		:stepper_warning="[]"
		:stepper_danger="[]"
		:completed="5"
		/>
		<previewImage
		imgSize= "92px"
		:error="false" 
		:img="val.value.img" 
		@chengeFile="(e) => { uploadTF('img', e[0]); }" 
		/>
		<textareaInput 
			label="متن درباره من"
			:value="val.value.about_me"
			@blurinputTxtFunc="(e) => { val.value.about_me = e; p_sav('about_me') }" 
		/>
		<div class="w-100 overflow-hidden mt-3">
			<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 float-right p-0">				
				<file_cloud 
					accept="video/mp4"
					label="ویدئو (اختیاری)"
					:error="false"
					:files="val.value.video"
					@chengeFile="(e) => { uploadTF('video', e[0]);  }"
					@removeFile="(e) => { val.value.video = e;  p_sav('video'); }"
					v-if="val.value.video.length==0"
					/>
				<video 
				class="w-100 border-15"
				controls
				v-else
				>
					<source 
					:src="imgurl + val.value.video[0].fileUpload" 
					type="video/mp4"
					>
				</video>
			</div>
			<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 float-right"
				:class="(windowWidth > 770) ? 'pl-0' : 'p-0'">
				<file_cloud 
					label="بارگزاری تصاویر (اختیاری)"
					:error="false"
					:files="val.value.image_teacher"
					@chengeFile="(e) => { uploadTF('image_teacher', e[0]);  }"
					@removeFile="(e) => { val.value.image_teacher = e;  p_sav('image_teacher'); }"
				/>
			</div>
		</div>
		<btn text='ثبت نهایی'
			class="pt-3 w-100" 
			textClass="w-100" 
			@clickMe="setPage();"
		/>
	</div>
</template>

<script>
	import multi_step_progress from "../../UI/progress/multi_step_progress.vue";
	import btn from "../../UI/button/btn.vue";
	import previewImage from "../../UI/uploadFile/previewImage.vue";
	import textareaInput from "../../UI/input/textareaInput.vue";
	import file_cloud from "../../UI/uploadFile/file_cloud.vue";
	import { success, error, loading, success_sm } from "../../assets/library/messege.js";

	export default {
		name: 'teaching_information',
		data(){
			return {
				success_sm: success_sm,
				error: error,
				success: success,
				loading: loading,
				imgurl: window.imgurl,
			}
		},
		components: {
			btn,
			textareaInput,
			previewImage,
			multi_step_progress,
			file_cloud,
		},
		props: {
			val: {
				default: {
					page: 1,
				},
			},
		},
		mounted(){

		},
		methods:{
		uploadTF(val, e, THIS = this) {
			THIS.loading(THIS);
			var format =  ["jpg", "jpeg", "png", "pdf"];
			var idImg =  "t_[DATE]_[RANDOM]";
			if(val == "img"){
				format = ["jpg", "jpeg", "png"];
				idImg = "t_"+this.val.value.id;
			}
			if(val == "video"){
				format = ["mp4"];
			}
			var formData = new FormData();
			formData.append("file", e);
			formData.append("format",format);
			formData.append("idImg", idImg);
			var xhttp = new XMLHttpRequest();
			xhttp.open("POST", window.upldurl, true);
			xhttp.onreadystatechange = function () {
				if (this.readyState == 4 && this.status == 200) {
					this.getVar = JSON.parse(this.responseText);
					if (this.getVar.response == 1) {
						let F = {
							fileName: this.getVar.filename,
							fileUpload: this.getVar.uploadFileName,
						};
						if(val != "img"){
							THIS.val.value[val].push(F);
							THIS.p_sav(val);
						}else{
							THIS.val.value.img = F.fileUpload;
						}
						THIS.success_sm(THIS);
					} else {
						THIS.error(THIS, "فرمت فایل باید "+format[0]+" باشد");
					}
				}
			};
			xhttp.send(formData);
		},
//********************************************************** */
setPage(){
	if(this.val.value.img=='' || this.val.value.about_me=='') {
		this.error(this);
	}
		this.val.page = 8;
		// if(this.chechRole()){
			//this.val.id = this.$localStorage.get('s_id_t');
			this.val.value.status = 10;
			this.p_sav('status');
		// }
		this.$emit('next_page', this.val);
},
//********************************************************** */
p_sav(fild, THIS = this) {
	let f = (fild == "category") ? 'cats' : fild;
	let v = this.val.value[fild];
	if(this.val.value[fild] == true){
		v = 1;
	} else if(this.val.value[fild] == false){
		v = 0;
	}
	if(this.$localStorage.get('user')) {
		window.$.post(window.baseurl + 'accountTeacher/step_teacher', {fild: f ,val: v, id: this.val.id, admin: this.$localStorage.get('user')}, function () {
			THIS.$localStorage.remove('s_id_t');
		}, "json");
	} else {
		window.$.post(window.baseurl + 'accountTeacher/step_teacher', {fild: f ,val: v, id: this.val.id}, function () {
			THIS.$localStorage.remove('s_id_t');
		}, "json");
	}
	
},			
//********************************************** */
chechRole(){
	let user = this.$localStorage.get('user');
	if(user == null){
		return true;
	}else if(user.username.role != 3){
		return true;
	}else{
		return false;
	}
},
//********************************************** */
		}
	}
</script>
<style>

</style>
